<template>
  <div class="page tmdRepaymentConfirm">
    <navigation class="header flex-shrink0">确认还款</navigation>
    <section class="section flex-shrink0">
      <div class="card">
        <div class="platform" v-if="isShowLogo">
          <img class="icon" :src="platform.icon" />
          <span class="name">{{ platform.name }}</span>
        </div>
        <div class="card-amount">
          <h2 class="title">还款金额 (元)</h2>
          <p>
            {{ totalAmount() | currency }}
            <img v-if="repaymentTrail.repayTrailV2DTO.wavAmt" @click="showDetail" src="./images/icon_info.png" srcset="
                            ./images/icon_info@2x.png 2x,
                            ./images/icon_info@3x.png 3x
                        "
            />
          </p>
        </div>

        <!-- <div class="origin-amount" v-if="repaymentTrail.hasWav">
          应还金额：{{ repaymentTrail.beforWavAmount | currency }}
        </div> -->
        <div class="repay-list">

          <div class="repay-list-item" v-for="(item,index) in pageShowList" :key="index">
            <p class="thin">{{item.showName}}（元）</p>
            <p>{{ item.showAmt}}</p>
          </div>
          <!-- <div class="repay-list-item">
            <p class="thin">应还本金（元） </p>
            <p>{{ repaymentTrail.schdPrin | currency }}</p>
          </div>

          <div class="repay-list-item">
            <p class="thin">利息（元）</p>
            <p>{{ repaymentTrail.schdInt | currency }}</p>
          </div>

          <div class="repay-list-item" v-if="repaymentTrail.fee">
            <p class="thin">服务费（元）</p>
            <p>{{ repaymentTrail.fee | currency }}</p>
          </div>

          <div class="repay-list-item" v-if="repaymentTrail.intDelay">
            <p class="thin">罚息（元）</p>
            <p>{{ repaymentTrail.intDelay | currency }}</p>
          </div>
          <div class="repay-list-item" v-if="repaymentTrail.wavInt">
            <p class="thin">减免金额（元)</p>
            <p>{{ repaymentTrail.wavInt | currency }}</p>
          </div> -->

        </div>
      </div>

      <div class="repayment-type">
        <nd-choose name="type" v-model="form.type" :data="typeOptions" :valueKey="['key', 'description']" label="还款方式">
          <label class="label"><img src="./images/icon_fangshi.png" srcset="
                                ./images/icon_fangshi@2x.png 2x,
                                ./images/icon_fangshi@3x.png 3x
                            "
          />还款方式</label>
        </nd-choose>
      </div>

      <dl class="repayment-account" v-if="form.type === 'ONLINE'" @click="goBankCard">
        <div class="label info">
          <img src="./images/icon_card.png" srcset="
                            ./images/icon_card@2x.png 2x,
                            ./images/icon_card@3x.png 3x
                        "
          />
          <span>还款账户</span>
        </div>
        <span class="label content">
          <span class="card-info">{{ cardText }}</span>
          <img class="arrow" src="../../components/nd-cell/images/arrow.png" />
        </span>
      </dl>
      <div class="repament-decription" v-if="form.type === 'OFFLINE'">
        <div class="label">
          <img src="./images/icon_card.png" srcset="
                            ./images/icon_card@2x.png 2x,
                            ./images/icon_card@3x.png 3x
                        "
          />还款账户
        </div>
        <p>
          您可通过银行App转账还款或至银行办理转账还款
          您申请对账后，我们将尽快核实还款信息
        </p>
      </div>
      <div class="repayment-info" v-if="form.type === 'OFFLINE'">
        <div class="item">
          <label>借款平台</label>
          <span>{{ platform.name }}</span>
        </div>
        <div class="item">
          <label>账户名称</label>
          <span>{{ busAccInfo.accName }}</span>
        </div>
        <div class="item">
          <label>开户银行</label>
          <span>{{ busAccInfo.openBank }}</span>
        </div>
        <div class="item" @click="copyBankNo">
          <label>银行卡号</label>
          <span>{{ busAccInfo.accNo }}</span>
        </div>
      </div>
      <!-- <div v-if="form.type === 'OFFLINE'">
                <div class="service-button" @click="openVisible">
                    <img src="../../assets/images/call.png"/>
                    <span>联系客服</span>
                </div>
                <div class="service-title">还款后请点击对账按钮或联系客服</div>
            </div> -->
    </section>

    <div class="footer flex-shrink0">
      <nd-button class="btn" :disabled="!disabled" @click="confirmRepay">{{
        form.type === 'ONLINE' ? '确认还款' : '我已还款，发起对账'
      }}</nd-button>
    </div>

    <nd-dialog v-model="detailDialogVisible" @close="closeDialog" :footer="false" :close-btn="true">
      <div class="detail-dialog">
        <div class="title">还款金额</div>
        <div class="amount">
          ¥ {{ repaymentTrail.repayAmount | currency }}
        </div>
        <div class="item-container">

          <div class="item" v-for="(item,index) in  popShowList" :key="index">
            <label class="des">{{item.showName}}（元）</label>
            <label>{{ item.showAmt}}</label>
          </div>

          <!-- <div class="item">
            <label class="des">本金（元）</label>
            <label>{{ repaymentTrail.schdPrin | currency }}</label>
          </div>
          <div class="item">
            <label class="des">利息（元）</label>
            <label>{{ repaymentTrail.schdInt | currency }}</label>
          </div>
          <div v-if="repaymentTrail.fee" class="item">
            <label class="des">服务费（元）</label>
            <label>{{ repaymentTrail.fee | currency }}</label>
          </div>
          <div v-if="repaymentTrail.intDelay" class="item">
            <label class="des">罚息（元）</label>
            <label>{{ repaymentTrail.intDelay | currency }}</label>
          </div>
          <div v-if="repaymentTrail.wavInt" class="item">
            <label class="des">还款减免（元）</label>
            <label>{{ -repaymentTrail.wavInt | currency }}</label>
          </div> -->
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { copyToClipbord, isEmptyObject, getKey, setKey, isWxMiniprogram } from '../../assets/utils'

export default {
  name: 'tmd-repayment-confirm',

  data () {
    return {
      orderId: this.$route.query.orderId || '',
      canOffLineRepay: this.$route.query.canOffLineRepay || 'F',
      loanPlatform: this.$route.query.loanPlatform || 'YZD',
      fundCode: this.$route.query.fundCode || '',
      detailDialogVisible: false,
      termList: this.$storage.get('selectedTerms'),
      termId: this.$storage.get('selectedTerms')[0].termId, // 还款期数 查询银行卡需要
      repaymentTrail: this.$storage.get('trail') || {},
      busAccInfo: {},
      form: {
        type: 'ONLINE'
      },
      allPlatForm: [],
      selectedBankcard: {}, // 选择的银行卡
      isShowLogo: getKey('channel') !== 'API-WEIBO'
    }
  },

  async created () {
    await this.getPlatform()
    try {
      if (this.canOffLineRepay === 'T' || getKey('channel') === 'API-WEIBO') {
        await Promise.all([this.getBusAcc(), this.getBankcardList()])
      } else {
        await Promise.all([this.getBankcardList()])
      }
      this.$bus.$emit('ready')
    } catch (error) {
      this.$bus.$emit('error')
    }
  },

  computed: {
    showComponent () {
      return this.repaymentTrail?.repayTrailV2DTO?.showComponent || []
    },
    pageShowList () {
      return this.showComponent.filter(item => item.pageShow === 'Y')
    },
    popShowList () {
      return this.showComponent.filter(item => item.infoPopShow === 'Y')
    },
    typeOptions () {
      if (getKey('channel') === 'API-WEIBO') {
        return [{ key: 'OFFLINE', description: '线下还款' }]
      } else if (this.canOffLineRepay === 'T') {
        return [
          { key: 'ONLINE', description: '在线还款' },
          { key: 'OFFLINE', description: '线下还款' }
        ]
      } else {
        return [{ key: 'ONLINE', description: '在线还款' }]
      }
    },

    disabled () {
      if (this.form.type === 'ONLINE') {
        return this.selectedBankcard.bankCardNo || false
      } else {
        return true
      }
    },

    platform () {
      const platform = getKey('platform') || this.allPlatForm
      const result = platform && platform.find(item => item.loanPlatform === this.loanPlatform)
      if (result) {
        return {
          name: result.loanPlatformName,
          icon: result.iconUrl
        }
      }
      return {
        name: platform && platform['TMD'] && platform['TMD'].loanPlatformName,
        icon: platform && platform['TMD'] && platform['TMD'].iconUrl
      }
    },

    cardText () {
      if (this.selectedBankcard.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName}(${code})`
      } else {
        return `去绑卡`
      }
    }
  },

  watch: {
    detailDialogVisible (value) {
      this.$report({
        id: 10104,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2,
          visible: value ? 1 : 0
        }
      })
    }
  },

  methods: {
    ...mapActions('repay', ['getBusAccX', 'repayApplyX']),
    ...mapActions('bankcard', ['getBankcardListX']),
    ...mapActions('order', ['getPlatformX']),

    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: this.loanPlatform,
        fundCode: this.fundCode,
        productCd: 'TMDP',
        orderId: this.orderId,
        termId: this.termId
      })
      if (response.success && response.data.length > 0) {
        const bank = this.$store.state.bankcard.selectedBankcard
        const defaultBankFilter = response.data.filter(
          (item) => item.default
        )
        const defaultBank =
          defaultBankFilter.length > 0 ? defaultBankFilter[0] : null
        this.selectedBankcard = !isEmptyObject(bank) && response.data.filter(item => item.bankCardNo === bank.bankCardNo).length !== 0
          ? response.data.filter(item => item.bankCardNo === bank.bankCardNo)[0]
          : defaultBank || response.data[response.data.length - 1]
      }
    },
    totalAmount () {
      return this.repaymentTrail.repayAmount
    },

    goBankCard () {
      if (!this.selectedBankcard.bankCardNo && (this.loanPlatform === 'YZD' || this.loanPlatform === 'LFQ')) {
        this.$report({
          id: 10107
        })
        this.$router.push({
          path: '/bankcard/add',
          query: {
            position: 'repay',
            loanPlatform: this.loanPlatform,
            fundCode: this.fundCode,
            orderId: this.orderId,
            canChangePhoneNo:
              this.loanPlatform === 'YZD' ? 'false' : 'true',
            isWxMiniProgramRepay: isWxMiniprogram() ? 'Y' : ''
          }
        })
        return
      }
      this.$router.push({
        path: '/bankcard/list',
        query: {
          position: 'repay',
          orderId: this.orderId,
          loanPlatform: this.loanPlatform,
          fundCode: this.fundCode,
          termId: this.termId,
          isWxMiniProgramRepay: isWxMiniprogram() ? 'Y' : ''
        }
      })
    },

    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_reconciliation'
        }
      })
    },

    copyBankNo () {
      copyToClipbord(this.busAccInfo.accNo)
      this.$message('银行卡号复制成功')
    },

    async getBusAcc () {
      try {
        const params = {
          loanPlatform: this.loanPlatform,
          orderId: this.orderId,
          terms: this.termList.map((item) => item.repaymentIndex),
          fundCode: this.fundCode
        }
        const response = await this.getBusAccX(params)
        if (response.success) {
          this.busAccInfo = response.data || {}
        }
      } catch (exp) {
        console.log(exp)
      }
    },

    showDetail () {
      this.$report({
        id: 10103,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2
        }
      })
      this.detailDialogVisible = true
    },
    async confirmRepay () {
      if (this.selectedBankcard.invalid) {
        return this.reBind()
      }
      this.$report({
        id: 10102,
        args: {
          position: this.loanPlatform,
          target: this.form.type === 'ONLINE' ? 1 : 2
        }
      })
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      let channel = getKey('channel') ? { channel: getKey('channel') } : {}
      const params = {
        repayMode: this.form.type,
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        fundCode: this.fundCode,
        bankCardNo:
          this.form.type === 'ONLINE'
            ? this.selectedBankcard.bankCardNo
            : '',
        terms: this.termList.map((item) => item.repaymentIndex),
        totalAmt: this.repaymentTrail.repayAmount,
        ...trafficCode,
        ...channel
      }
      const response = await this.repayApplyX(params)

      if (response.code === '100018') {
        this.reBind()
        return
      }
      if (response.code === '200001') {
        window.location.href = getKey('successUrl')
      }
      if (response.success) {
        this.$statistics('REPAY_SUB_SUC')
        if (['API-XHQB'].includes(getKey('channel'))) {
          window.location.href = this.repaymentTrail.successUrl
        } else if (['API-WEIBO'].includes(getKey('channel'))) {
          window.location.href = getKey('successUrl')
        } else {
          this.$router.push({
            path: '/repayment/result',
            query: {
              repayId: response.data,
              loanPlatform: this.loanPlatform,
              type: this.form.type.toLowerCase(),
              orderId: this.orderId,
              fundCode: this.fundCode
            }
          })
        }
      } else {
        if (['API-XHQB'].includes(getKey('channel'))) {
          window.location.href = this.repaymentTrail.failUrl
        } else if (['API-WEIBO'].includes(getKey('channel'))) {
          window.location.href = getKey('successUrl')
        }
        this.$statistics('REPAY_SUB_FAIL', {
          comment: response.msg
        })
      }
    },
    reBind () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          bankcardNo: this.selectedBankcard.bankCardNo,
          bankMobile: this.selectedBankcard.bankMobile,
          loanPlatform: this.$route.query.loanPlatform,
          fundCode: this.$route.query.fundCode,
          termId: this.$route.query.termId,
          orderId: this.$route.query.orderId,
          canChangePhoneNo: this.selectedBankcard.canChangePhoneNo,
          isWxMiniProgramRepay: isWxMiniprogram() ? 'Y' : ''
        }
      })
    },
    // 获取平台枚举
    async getPlatform () {
      const res = await this.getPlatformX()
      if (res.code === '000000') {
        setKey('platform', res.data)
        this.allPlatForm = res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.flex-shrink0 {
  flex-shrink: 0;
}

.label {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  >img {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
}

.page {
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;

  .section {
    // overflow: scroll;
    flex: 1;
    padding: 30px;

    .card {
      border-radius: 20px;
      padding: 22px 0 0 0;
      background-color: #ffffff;
      box-sizing: border-box;

      .platform {
        padding: 0 30px;
        height: 36px;
        line-height: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
          width: 36px;
          height: 36px;
        }

        .name {
          font-size: 26px;
          padding-left: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .card-amount {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 65px;
        font-size: 72px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 67px;
        text-align: center;
        h2 {
          font-weight: 400;
          font-size: 24px;
          color: #333333;
        }
        img {
          width: 23px;
          height: 23px;
          margin-bottom: 20px;
        }
      }

      .origin-amount {
        font-size: 24px;
        height: 33px;
        line-height: 33px;
        margin-top: 13px;
        text-align: center;
        text-decoration: line-through;
        color: @fc3;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }

      .repay-list {
        margin-top: 74px;
        display: grid;
        grid-template-columns: 50% 50%;
        // grid-row-gap: 7px;
        font-size: 24px;
        text-align: left;
        color: #333333;
        line-height: 33px;

        .repay-list-item {
          border-top: 1px solid #EEEEEE;
          border-bottom: 1px solid #EEEEEE;
          height: 99px;
          padding: 14px 30px 11px;

          &:nth-child(2n-1) {
            border-right: 1px solid #EEEEEE;
          }

          .thin {
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            margin-bottom: 4px;
          }
        }
      }
    }

    .repayment-type {
      margin-top: 30px;
      background-color: #ffffff;
      padding: 35px;
      border-radius: 20px;

      .label img {
        width: 44px;
        height: 44px;
      }
    }

    .repayment-account {
      margin-top: 30px;
      background-color: #ffffff;
      padding: 35px;
      border-radius: 20px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;

      .content {
        .card-info {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 40px;
          margin-right: 10px;
        }

        .arrow {
          width: 9px;
          height: 16px;
          margin-right: 0px;
        }
      }
    }

    .repament-decription {
      margin-top: 30px;
      background-color: #ffffff;
      border-radius: 20px;
      padding: 30px;

      >p {
        margin-top: 40px;
        margin-left: 10px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 37px;
      }
    }

    .repayment-info {
      margin-top: 30px;
      background-color: #ffffff;
      border-radius: 20px;
      padding: 30px 40px;

      .item {
        display: flex;
        margin: 8px 0;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;

        >label {
          margin-right: 56px;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }

  .footer {
    height: 180px;
    background-color: #ffffff;

    .btn {
      margin: 28px auto 0;
    }
  }

  .detail-dialog {
    margin: 0px 0px 57px 45px;

    .title {
      font-size: 42px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 72px;
    }

    .amount {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
      margin-top: 12px;
    }

    .item-container {
      margin-top: 32px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;

      .item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .des {
          width: 190px;
        }
      }
    }
  }

  .service-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 60px auto 0;
    width: 200px;
    height: 60px;
    background: #FAFAFA;
    border-radius: 40px;
    border: 1px solid #EEEEEE;
    padding: 0 23px 0 28px;

    >img {
      width: 29px;
      height: 29px;
    }

    >span {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .service-title {
    margin: 16px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #C2C2C2;
    text-align: center;
  }
}
</style>
